import { render, staticRenderFns } from "./Jdqs.vue?vue&type=template&id=4dc4cc4d&scoped=true&"
import script from "./Jdqs.vue?vue&type=script&lang=js&"
export * from "./Jdqs.vue?vue&type=script&lang=js&"
import style0 from "./Jdqs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Jdqs.vue?vue&type=style&index=1&id=4dc4cc4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4cc4d",
  null
  
)

export default component.exports